module.exports = __webpack_public_path__ + "img/type11.6730b456.png";